import React from "react";

function Title({ children }) {
  return <div className="my-8 text-3xl text-blue-100">{children}</div>;
}

export default Title;
